import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import config from './firebaseRef'
import axios from 'axios'

firebase.initializeApp(config)

const userRef = firebase.database().ref('user')
async function checkUserProfile ({uid, email}) {
  let snapshot = await userRef.once('value')
  // .then(snapshot => {
  // })
  if (!snapshot.hasChild(uid)) {
    userRef.child(uid).set({
      role: 'vendor',
      email
    })
  } else {
    let userProfileRef = await userRef.child(uid).once('value')
    console.log(userProfileRef.val())
    store.dispatch('userProfile', userProfileRef.val())
  }
}

firebase.auth().onAuthStateChanged(user => {
  if (user) {
    // login success fires
    console.log(user)
    checkUserProfile(user)
  }
  store.dispatch('user', user || {})
  // initial no log and loging-out fire
  store.dispatch('authed', user !== null)

  /* get foreign exchange price */
  axios.get('https://www.intrinotify.io/callFixApi')
  .then(function (response) {
    const { data: newPrice } = response
    /* due to the base currency is EUR, needed to add it manually */
    // console.table(newPrice.rates)
    newPrice.rates.EUR = 1
    store.dispatch('updateForeignExchangePrice', newPrice)
  })
  .catch(function (error) {
    console.log(error)
  })
})

const AUTH_STATE_AUTHING = 0
const AUTH_STATE_NOAUTH = 1
export const AUTH_STATE_AUTHED = 2
const storedState = {
  authState: AUTH_STATE_AUTHING,
  user: {},
  foreignExchangePrice: {},
  selectedCurrency: {
    symbol: '€',
    code: 'EUR',
    symbol_native: '€',
    decimal_digits: 2,
    rounding: 0,
    /* add on rates */
    rates: 1
  }
}
const mutations = {
  authed (state, authed) {
    state.authState = authed ? AUTH_STATE_AUTHED : AUTH_STATE_NOAUTH
  },
  user (state, content) {
    state.user = {
      email: content.email
    }
  },
  userProfile (state, profile) {
    state.user = {
      ...state.user,
      ...profile
    }
  },
  updateForeignExchangePrice (state, newPrice) {
    state.foreignExchangePrice = {
      ...state.foreignExchangePrice,
      ...newPrice
    }
  },
  selectNewCurrency (state, newCurr) {
    state.selectedCurrency = {
      ...state.selectedCurrency,
      ...newCurr,
      rates: state.foreignExchangePrice.rates[newCurr.code]
    }
  }
}

Vue.use(Vuex)
export const store = new Vuex.Store({
  state: storedState,
  mutations,
  strict: process.env.NODE_ENV !== 'production'
})

export function login (...arg) {
  return firebase.auth().signInWithEmailAndPassword(...arg)
}

export function resetPassword (mail) {
  return firebase.auth().sendPasswordResetEmail(mail)
}

export function firebaseLogout () {
  return firebase.auth().signOut()
}

function delay (sec = 1) {
  if (sec > 10) return console.log('delay cannot bigger than 10s')
  return new Promise(resolve => {
    setTimeout(resolve, sec * 1000)
  })
}

export async function getAuthState () {
  // eslint-disable-next-line
  while (storedState.authState === AUTH_STATE_AUTHING) {
    await delay(1)
    console.log('waiting auth')
  }
  return storedState.authState === AUTH_STATE_AUTHED
}

export function getFireBase () {
  return firebase
}

export function getService (origin) {
  if (origin == null) {
    return firebase.database().ref('services')
  } else {
    return firebase.database().ref('services').orderByChild('from').equalTo(origin)
  }
}



// WEBPACK FOOTER //
// ./src/index.js